import plaidBankIcon from "../../assets/plaidBankIcon.svg";
import { Button } from "../button/index.jsx";
import React from "react";
import { StyledBankLogo } from "./styled.jsx"
import PropTypes from "prop-types";
import { Trans, useTranslation } from 'react-i18next';

export const OBVOnlyBodyContent = ({setViewTC, obvInfo, handleConfirm}) => {
  const { accountSubType } = obvInfo;
  const { t } = useTranslation();

  return (
      <>
        <div className='topSection'>
          <StyledBankLogo className='plaidBankIcon' src={plaidBankIcon}
               alt='plaidBankIcon'/>
          <div className='textContent'>
            <h1>{t('obv.message.ready')}</h1>
            <p>
              <b>{t('obv.labels.bank_account')}:</b>
            </p>
            <p>{obvInfo.institutionName} {accountSubType.charAt(0).toUpperCase()
            + accountSubType.slice(1)} account **&nbsp;{obvInfo.accountMask}</p>
          </div>
        </div>
        <div className='bottomSection'>
          <div className='tcContainer' role="button"
               tabIndex={0} onClick={() => setViewTC(true)} onKeyDown={() => setViewTC(true)}>
            <h6>
              <Trans
                i18nKey="common.terms.agreement"
                components={{
                  bold: <b />
                }}
              />
            </h6>
          </div>
          <Button type='default'
                  onClick={() => handleConfirm(obvInfo.clientReferenceId)}>
            {t('obv.button.continue')}
          </Button>
        </div>
      </>
  );
}

OBVOnlyBodyContent.propTypes = {
  setViewTC: PropTypes.bool,
  obvInfo: PropTypes.object,
  handleConfirm: PropTypes.func,
};